import Vue from 'vue'
import { Button, PageHeader, ConfigProvider, DatePicker, Form, FormModel, Input, Message, Icon, Layout, Table, Select, checkbox } from 'ant-design-vue'
Vue.use(Button)
Vue.use(PageHeader)
Vue.use(DatePicker)
Vue.use(ConfigProvider).use(Form).use(Input).use(FormModel).use(Icon).use(Layout).use(Table).use(Select).use(checkbox)
Vue.prototype.$message = Message
